"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductsByBrandErrors = void 0;
var UseCaseError_1 = require("../../../../models/concrete/UseCaseError");
exports.getProductsByBrandErrors = [
    UseCaseError_1.UseCaseError.create('invalidData'),
    UseCaseError_1.UseCaseError.create('notFound'),
    UseCaseError_1.UseCaseError.create('problemInProcess')
];
//# sourceMappingURL=getProductsByBrandErrors.js.map